import Vue from "vue";
import Vuex from "vuex";
import userVUEX from "./modules/userVUEX.js";
import headerVUEX from "./modules/headerVUEX.js";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    userVUEX,
    headerVUEX,
  },
});
